import AllRewardsListContainer from './container/AllRewardsListContainer';
import { useSelector } from 'react-redux';
import { Spinner } from '../_shared/index.js';

const Allrewards = () => {
	const company = useSelector((state) => state.user.currentUser.company);
	if (!company) return <Spinner />;
	return <AllRewardsListContainer />;
};

export default Allrewards;
